import { Redirect } from 'react-router-dom'
import Auth from './Auth'
import lazyWithRetry from './utilities/lazyWithRetry'

const Login = lazyWithRetry(() => import('./pages/Login/Login'))
const ForgotPassword = lazyWithRetry(
  () => import('./pages/Password/ForgotPassword')
)
const ResetPassword = lazyWithRetry(
  () => import('./pages/Password/ResetPassword')
)
const PartnerManagement = lazyWithRetry(
  () => import('./pages/Organization/PartnerManagement')
)
const CustomerManagement = lazyWithRetry(
  () => import('./pages/Organization/CustomerManagement')
)
const UserManagement = lazyWithRetry(
  () => import('./pages/UserManagement/UserManagement')
)
const RateCardsManagement = lazyWithRetry(
  () => import('./pages/RateCardsManagement/RateCardsManagement')
)
const RateCardCreation = lazyWithRetry(() => import('./pages/RateCardCreation'))
const PaymentAdjustments = lazyWithRetry(
  () => import('./pages/FleetSettlement/PaymentAdjustments')
)
const ParcelDownload = lazyWithRetry(
  () => import('./pages/ParcelDownloadTool/ParcelDownload')
)
const QuarantineShipment = lazyWithRetry(
  () => import('./pages/QuarantineShipment/QuarantineShipment')
)
const BEFManagement = lazyWithRetry(
  () => import('./pages/BEFManagement/BEFManagement')
)
const BEFSummary = lazyWithRetry(() => import('./pages/BEFSummary/BEFSummary'))
const WorkOrderManagement = lazyWithRetry(
  () => import('./pages/WorkOrderManagement/WorkOrderManagement')
)
const CARateCardPartnerCarrier = lazyWithRetry(
  () => import('./pages/CARateCardPartnerCarrier/CARateCardPartnerCarrier')
)
const CARateCardManagement = lazyWithRetry(
  () => import('./pages/CARateCardManagement/CARateCardManagement')
)
const CARateCardCreation = lazyWithRetry(
  () => import('./pages/CARateCardCreation')
)
const SLAExtensionRequest = lazyWithRetry(
  () => import('./pages/SLAExtensionRequest/SLAExtensionRequest')
)
const SLAExtensionHistory = lazyWithRetry(
  () => import('./pages/SLAExtensionHistory/SLAExtensionHistory')
)
const ApproveTaskCenter = lazyWithRetry(
  () => import('./pages/ApproveTaskCenter')
)
const RateCardsCommonZoneList = lazyWithRetry(
  () => import('./pages/RateCardsCommonZoneList/RateCardsCommonZoneList')
)
const ZoneChartManagement = lazyWithRetry(
  () => import('./pages/ZoneChartManagement')
)
const FleetBilling = lazyWithRetry(
  () => import('./pages/FleetBilling/FleetBilling')
)
// Phase 1: Detail page excluded — uncomment for Phase 2
// const FleetBillingDetail = lazyWithRetry(
//   () => import('./pages/FleetBillingDetail/FleetBillingDetail')
// )
// Phase 1: Fleet Invoice excluded — uncomment when ready
// const FleetInvoice = lazyWithRetry(
//   () => import('./pages/FleetInvoice/FleetInvoice')
// )
const CABillingManagement = lazyWithRetry(
  () => import('./pages/CABillingManagement/CABillingManagement')
)
const CABillingSupplementary = lazyWithRetry(
  () => import('./pages/CABillingSupplementary/BillingSupplementary')
)
const CAInvoiceManagement = lazyWithRetry(
  () => import('./pages/CAInvoiceManagement/InvoiceManagement')
)
const CAInvoiceNumberGenerator = lazyWithRetry(
  () => import('./pages/CAInvoiceNumberGenerator/index')
)
const MerchantManagement = lazyWithRetry(
  () => import('./pages/MerchantManagement/MerchantManagement')
)
const MetricsPage = lazyWithRetry(
  () => import('./pages/MetricsPage/MetricsPage')
)
const PaymentProof = lazyWithRetry(
  () => import('./pages/PaymentProof/PaymentProof')
)
const ClaimDataExport = lazyWithRetry(
  () => import('./pages/ClaimDataExport/ClaimDataExport')
)
const DelegationManagement = lazyWithRetry(
  () => import('./pages/DelegationManagement/DelegationManagement')
)
const DriverPriceCards = lazyWithRetry(
  () => import('./pages/DriverSettlement/DriverPriceCards')
)
const SettlementCycle = lazyWithRetry(
  () => import('./pages/DriverSettlement/SettlementCycle')
)
const ReportRecipient = lazyWithRetry(
  () => import('./pages/DriverSettlement/ReportRecipient')
)
const SameAddressMultiOrder = lazyWithRetry(
  () => import('./pages/DriverSettlement/SameAddressMultiOrder')
)
const InsuranceDeductionWaiver = lazyWithRetry(
  () => import('./pages/DriverSettlement/InsuranceDeductionWaiver')
)
const Blacklist = lazyWithRetry(
  () => import('./pages/DriverSettlement/Blacklist')
)
export const routes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/forgot-password',
    component: ForgotPassword
  },
  {
    path: '/reset-password',
    component: ResetPassword
  },
  {
    component: Auth,
    routes: [
      {
        path: '/metrics-page',
        component: MetricsPage
      },
      {
        path: '/organization-partner',
        component: PartnerManagement
      },
      {
        path: '/organization-customer',
        component: CustomerManagement
      },
      {
        path: '/user-management',
        component: UserManagement
      },
      {
        path: '/administration-delegation-management',
        component: DelegationManagement
      },
      {
        path: '/merchant-management',
        component: MerchantManagement
      },
      {
        path: '/billing-quarantine-shipment',
        component: QuarantineShipment
      },
      {
        path: '/billing-bef-management',
        component: BEFManagement
      },
      {
        path: '/billing-bef-summary',
        component: BEFSummary
      },
      {
        path: '/billing-work-order-management',
        component: WorkOrderManagement
      },
      {
        path: '/rate-card-management',
        component: RateCardsManagement
      },
      {
        path: '/rate-card-creation',
        component: RateCardCreation
      },
      {
        path: '/ca-rate-card-partner-carrier',
        component: CARateCardPartnerCarrier
      },
      {
        path: '/ca-rate-card-management',
        component: CARateCardManagement
      },
      {
        path: '/ca-rate-card-creation',
        component: CARateCardCreation
      },
      {
        path: '/rate-card-commonzone-list',
        component: RateCardsCommonZoneList
      },
      {
        path: '/fleet-settlement-payment-adjustments',
        component: PaymentAdjustments
      },
      {
        path: '/fleet-settlement-billing',
        component: FleetBilling
      },
      // Phase 1: Detail page excluded — uncomment for Phase 2
      // {
      //   path: '/fleet-settlement-billing-detail',
      //   component: FleetBillingDetail
      // },
      // Phase 1: Fleet Invoice excluded — uncomment when ready
      // {
      //   path: '/fleet-settlement-invoice',
      //   component: FleetInvoice
      // },
      {
        path: '/driver-settlement-price-cards',
        component: DriverPriceCards
      },
      {
        path: '/driver-settlement-settlement-cycle',
        component: SettlementCycle
      },
      {
        path: '/driver-settlement-report-recipient',
        component: ReportRecipient
      },
      {
        path: '/driver-settlement-same-address-multi-order',
        component: SameAddressMultiOrder
      },
      {
        path: '/driver-settlement-insurance-deduction-waiver',
        component: InsuranceDeductionWaiver
      },
      {
        path: '/driver-settlement-blacklist',
        component: Blacklist
      },
      {
        path: '/order-download-tool',
        component: ParcelDownload
      },
      {
        path: '/ka-toolkits-sla-ext-request',
        component: SLAExtensionRequest
      },
      {
        path: '/ka-toolkits-sla-ext-hist',
        component: SLAExtensionHistory
      },
      {
        path: '/approve-task-center',
        component: ApproveTaskCenter
      },
      {
        path: '/rate-card-conversion',
        component: ZoneChartManagement
      },
      {
        path: '/ca-billing-management',
        component: CABillingManagement
      },
      {
        path: '/ca-billing-supplementary',
        component: CABillingSupplementary
      },
      {
        path: '/ca-billing-invoice-management',
        component: CAInvoiceManagement
      },
      {
        path: '/ca-billing-invoice-number-generator',
        component: CAInvoiceNumberGenerator
      },
      {
        path: '/billing-payment-proof',
        component: PaymentProof
      },
      {
        path: '/order-download-claim-data',
        component: ClaimDataExport
      }
    ]
  }
]

export const prefetchMap = {
  '/metrics-page': () => import('./pages/MetricsPage/MetricsPage'),
  '/organization-partner': () =>
    import('./pages/Organization/PartnerManagement'),
  '/organization-customer': () =>
    import('./pages/Organization/CustomerManagement'),
  '/user-management': () => import('./pages/UserManagement/UserManagement'),
  '/administration-delegation-management': () =>
    import('./pages/DelegationManagement/DelegationManagement'),
  '/merchant-management': () =>
    import('./pages/MerchantManagement/MerchantManagement'),
  '/billing-quarantine-shipment': () =>
    import('./pages/QuarantineShipment/QuarantineShipment'),
  '/billing-bef-management': () =>
    import('./pages/BEFManagement/BEFManagement'),
  '/billing-bef-summary': () => import('./pages/BEFSummary/BEFSummary'),
  '/billing-work-order-management': () =>
    import('./pages/WorkOrderManagement/WorkOrderManagement'),
  '/rate-card-management': () =>
    import('./pages/RateCardsManagement/RateCardsManagement'),
  '/rate-card-creation': () => import('./pages/RateCardCreation'),
  '/ca-rate-card-partner-carrier': () =>
    import('./pages/CARateCardPartnerCarrier/CARateCardPartnerCarrier'),
  '/ca-rate-card-management': () =>
    import('./pages/CARateCardManagement/CARateCardManagement'),
  '/ca-rate-card-creation': () => import('./pages/CARateCardCreation'),
  '/rate-card-commonzone-list': () =>
    import('./pages/RateCardsCommonZoneList/RateCardsCommonZoneList'),
  '/fleet-settlement-payment-adjustments': () =>
    import('./pages/FleetSettlement/PaymentAdjustments'),
  '/fleet-settlement-billing': () =>
    import('./pages/FleetBilling/FleetBilling'),
  // Phase 1: Detail page excluded — uncomment for Phase 2
  // '/fleet-settlement-billing-detail': () =>
  //   import('./pages/FleetBillingDetail/FleetBillingDetail'),
  // Phase 1: Fleet Invoice excluded — uncomment when ready
  // '/fleet-settlement-invoice': () =>
  //   import('./pages/FleetInvoice/FleetInvoice'),
  '/driver-settlement-price-cards': () =>
    import('./pages/DriverSettlement/DriverPriceCards'),
  '/driver-settlement-settlement-cycle': () =>
    import('./pages/DriverSettlement/SettlementCycle'),
  '/driver-settlement-report-recipient': () =>
    import('./pages/DriverSettlement/ReportRecipient'),
  '/driver-settlement-same-address-multi-order': () =>
    import('./pages/DriverSettlement/SameAddressMultiOrder'),
  '/driver-settlement-insurance-deduction-waiver': () =>
    import('./pages/DriverSettlement/InsuranceDeductionWaiver'),
  '/driver-settlement-blacklist': () =>
    import('./pages/DriverSettlement/Blacklist'),
  '/order-download-tool': () =>
    import('./pages/ParcelDownloadTool/ParcelDownload'),
  '/ka-toolkits-sla-ext-request': () =>
    import('./pages/SLAExtensionRequest/SLAExtensionRequest'),
  '/ka-toolkits-sla-ext-hist': () =>
    import('./pages/SLAExtensionHistory/SLAExtensionHistory'),
  '/approve-task-center': () => import('./pages/ApproveTaskCenter'),
  '/rate-card-conversion': () => import('./pages/ZoneChartManagement'),
  '/ca-billing-management': () =>
    import('./pages/CABillingManagement/CABillingManagement'),
  '/ca-billing-supplementary': () =>
    import('./pages/CABillingSupplementary/BillingSupplementary'),
  '/ca-billing-invoice-management': () =>
    import('./pages/CAInvoiceManagement/InvoiceManagement'),
  '/ca-billing-invoice-number-generator': () =>
    import('./pages/CAInvoiceNumberGenerator/index'),
  '/billing-payment-proof': () => import('./pages/PaymentProof/PaymentProof'),
  '/order-download-claim-data': () =>
    import('./pages/ClaimDataExport/ClaimDataExport')
}
